export const albumData = {
  data: {
    _id: "64cee72fe41f6d0a8b0cd0bd",
    title: "Zihaal e Miskin",
    artists: [
      {
        _id: "64ce7c0bbbbada037c35edc9",
        name: "Javed-Mohsin",
        description:
          "An emotive journey, blending heartbreak and hope in soul-stirring symphonies. A genre-defying artist of substance.",
        image:
          "https://newton-project-resume-backend.s3.ap-south-1.amazonaws.com/4fed19ed-3599-4a84-80d6-4808d057cc41size_xl_1649058181.webp",
        languages: ["punjabi", "tamil", "hindi", "telugu"],
        songs: [
          "64cf908747ae38c3e33a1967",
          "64cf908847ae38c3e33a1978",
          "64cf90c547ae38c3e33a1e51",
          "64cf916a47ae38c3e33a2b9c",
          "64cf916c47ae38c3e33a2bbf",
          "64cf917047ae38c3e33a2c0c",
          "64cf927247ae38c3e33a402b",
          "64cf92a147ae38c3e33a43cf",
          "64cf931e47ae38c3e33a4dc8",
        ],
        appType: "music",
        __v: 9,
      },
      {
        _id: "64ce7c0bbbbada037c35ee23",
        name: "Vishal Mishra",
        description:
          "Unconventional and daring, reinventing themselves with each project. A true visionary in the world of music.",
        image:
          "https://newton-project-resume-backend.s3.ap-south-1.amazonaws.com/1e44a4e0-b9dd-471f-a064-d430b4bdb75fsize_xl_1648648894.webp",
        languages: ["tamil", "hindi", "telugu", "marathi", "bhojpuri"],
        songs: [
          "64cf90c547ae38c3e33a1e51",
          "64cf91c047ae38c3e33a329d",
          "64cf91d447ae38c3e33a3437",
          "64cf92bb47ae38c3e33a45ab",
          "64cf92c647ae38c3e33a4688",
          "64cf949647ae38c3e33a6c29",
        ],
        appType: "music",
        __v: 6,
      },
      {
        _id: "64ce7c0bbbbada037c35ee24",
        name: "Shreya Ghoshal",
        description:
          "Enigmatic and passionate, a true artist with a purpose. A musical journey that resonates deeply with fans.",
        image:
          "https://newton-project-resume-backend.s3.ap-south-1.amazonaws.com/25e888db-878e-415e-a7ea-f747d7130424size_xl_1516788943.webp",
        languages: [
          "punjabi",
          "tamil",
          "urdu",
          "hindi",
          "bengali",
          "telugu",
          "malayalam",
          "kannada",
          "english",
          "marathi",
          "assamese",
          "odia",
          "bhojpuri",
          "gujarati",
          "rajasthani",
        ],
        songs: [
          "64cf90c547ae38c3e33a1e51",
          "64cf911547ae38c3e33a24c8",
          "64cf911e47ae38c3e33a257b",
          "64cf914f47ae38c3e33a296c",
          "64cf915447ae38c3e33a29ca",
          "64cf916a47ae38c3e33a2b9c",
          "64cf916c47ae38c3e33a2bbf",
          "64cf916d47ae38c3e33a2bcc",
          "64cf917047ae38c3e33a2c0c",
          "64cf91d747ae38c3e33a3479",
          "64cf91e847ae38c3e33a35c1",
          "64cf925847ae38c3e33a3e92",
          "64cf927247ae38c3e33a402b",
          "64cf927447ae38c3e33a4059",
          "64cf928647ae38c3e33a41c6",
          "64cf92be47ae38c3e33a45e6",
          "64cf92c247ae38c3e33a4642",
          "64cf931147ae38c3e33a4cae",
          "64cf938147ae38c3e33a55ca",
          "64cf938247ae38c3e33a55df",
          "64cf938347ae38c3e33a55f2",
          "64cf938347ae38c3e33a55fe",
          "64cf938447ae38c3e33a5615",
          "64cf941147ae38c3e33a617d",
          "64cf941247ae38c3e33a619e",
          "64cf941547ae38c3e33a61d0",
          "64cf943747ae38c3e33a6494",
          "64cf947647ae38c3e33a69a0",
          "64cf947b47ae38c3e33a6a02",
          "64cf94ec47ae38c3e33a72fb",
        ],
        appType: "music",
        __v: 30,
      },
    ],
    description:
      "A vibrant tapestry of sounds, representing the myriad colors of India's musical heritage.",
    songs: [
      {
        // featured: null,
        // _id: "64cf90c547ae38c3e33a1e51",
        // title: "Zihaal e Miskin",
        // artist: [
        //   "64ce7c0bbbbada037c35edc9",
        //   "64ce7c0bbbbada037c35ee23",
        //   "64ce7c0bbbbada037c35ee24",
        // ],
        // album: "64cee72fe41f6d0a8b0cd0bd",
        // likedBy: [],
        // dateOfRelease: "2023-05-25T00:00:00.000Z",
        // type: "song",
        // mood: "happy",
        // thumbnail:
        //   "https://newton-project-resume-backend.s3.amazonaws.com/thumbnail/64cf90c547ae38c3e33a1e51.jpg",
        // appType: "music",
        // createdAt: "2023-08-06T12:23:33.434Z",
        // __v: 0,
        // audio_url:"https://newton-project-resume-backend.s3.amazonaws.com/audio/64cf90c547ae38c3e33a1e51.mp3",
      },
    ],
    image:
      "https://newton-project-resume-backend.s3.amazonaws.com/thumbnail/64cee72fe41f6d0a8b0cd0bd.jpg",
    release: "2023-05-25T00:00:00.000Z",
    createdAt: "2023-08-06T00:19:59.645Z",
    __v: 1,
  },
};
